export const CHECK_ICON = "/images/checkIcon.svg";
